import React from 'react';
import {
  Progress,
  ProgressProps,
  HStack,
  VStack,
  Text,
  chakra,
  forwardRef,
} from '@chakra-ui/react';
import { storageComponentSx } from 'app/components/Storage/styles';
import { StorageTooltip } from './StorageTooltip';
import { StorageLegend } from './StorageLegend';
import { getValues } from '../utils';
import { ExtendedStorageWidgetProps } from '../types';

export interface ProgressBarProps extends ProgressProps {
  values?: { [key: string]: number };
  colors?: { [key: string]: string };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ProgressBar = forwardRef<ProgressBarProps, 'div'>((props, ref) => (
  <Progress {...props} />
));

export const StorageWidget = ({
  totalUnit,
  usedUnit,
  total,
  used,
  status,
  boxProps,
  usedPersonal,
  usedShared,
  isOver,
}: ExtendedStorageWidgetProps) => {
  return (
    <VStack display="inline-flex" {...boxProps} mb="6px">
      <HStack w="full" alignItems="center">
        <Text
          fontSize="xs"
          lineHeight="small"
          color={status === 'OverLimit' ? 'R.80' : 'M.60'}
        >
          Using&nbsp;
          <chakra.span data-testid="used-storage" fontWeight={500}>
            {used}&nbsp;{usedUnit}
          </chakra.span>
          &nbsp;of&nbsp;
          <chakra.span data-testid="total-storage" fontWeight={500}>
            {total}&nbsp;{totalUnit}
          </chakra.span>
        </Text>
        <StorageTooltip />
      </HStack>
      <ProgressBar
        variant="multiSegment"
        min={0}
        max={100}
        values={getValues(usedPersonal, usedShared, isOver)}
        size="xs"
        sx={storageComponentSx.progressBar}
      />
      <StorageLegend usedPersonal={usedPersonal} usedShared={usedShared} />
    </VStack>
  );
};
